import { createApp } from 'vue'
import router from '@/router/index'
import App from './App.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/css/index.less'
const app = createApp(App)
app.use().use(router).use(ElementPlus).mount('#app')
